// extracted by mini-css-extract-plugin
export var badge = "badge-module--badge--YwAAS";
export var badge_new = "badge-module--badge_new--tFIgf";